class Rings {
  constructor (canvas, settings) {
    this.canvas = canvas
    this.ctx = this.canvas.getContext('2d', { alpha: false })
    this.settings = settings
    this.init()
  }

  init () {
    this.animationState = 's'
    this.addToRadius = 0
    this.currentColor = 0
    this.updateDemsnion(false)
    this.updateSettings(this.settings)
    this.ctx.strokeStyle = 'black'
    this.draw()
  }

  draw () {
    let radius
    for (let index = this.tempNumber - 1; index >= 0; index--) {
      this.ctx.beginPath()
      radius = Math.max(Math.ceil(index * this.size + this.addToRadius), 4)
      this.ctx.arc(0, 0, radius, 0, Math.PI * 2)
      if (radius * 2 < this.stroke) {
        this.ctx.lineWidth = radius * 2
      } else {
        this.ctx.lineWidth = this.stroke
      }
      this.ctx.fillStyle = this.colors[(index + this.currentColor) % 3]
      this.ctx.fill()
      if (this.stroke > 0) this.ctx.stroke()
    }
  }

  updateSettings (settings) {
    this.settings = settings
    this.colors = [settings.c1, settings.c2, settings.c3]
    this.stroke = settings.stroke
    const needRedraw = this.number !== settings.number
    this.number = settings.number
    this.size = Math.floor(Math.max(this.canvas.width, this.canvas.height) / (this.number * 2))
    this.tempNumber = Math.ceil(Math.max(this.canvas.width, this.canvas.height) / (this.size * 2 * 3)) * 3 + 3
    this.speed = settings.speed * 15
    this.ctx.lineWidth = this.stroke
    if (needRedraw || !(this.animationState === 'r')) {
      this.draw()
    }
  }

  updateDemsnion (draw = true) {
    this.ctx.resetTransform()
    this.ctx.lineWidth = this.stroke
    this.ctx.translate(this.canvas.width / 2, this.canvas.height / 2)
    this.size = Math.floor(Math.max(this.canvas.width, this.canvas.height) / (this.number * 2))
    this.tempNumber = Math.ceil(Math.max(this.canvas.width, this.canvas.height) / (this.size * 2 * 3)) * 3 + 3
    if (draw) this.draw()
  }

  animation () {
    const delta = Date.now() - this.lastRender
    this.addToRadius = this.addToRadius + Math.max(this.speed * (delta / 1000), 1)
    let radius
    for (let index = this.tempNumber - 1; index >= 0; index--) {
      this.ctx.beginPath()
      radius = Math.max(Math.ceil(index * this.size + this.addToRadius), 4)
      this.ctx.arc(0, 0, radius, 0, Math.PI * 2)
      if (radius * 2 < this.stroke) {
        this.ctx.lineWidth = radius * 2
      } else {
        this.ctx.lineWidth = this.stroke
      }
      this.ctx.fillStyle = this.colors[(index + this.currentColor) % 3]
      this.ctx.fill()
      if (this.stroke > 0) this.ctx.stroke()
    }
    if (this.addToRadius > this.size) {
      this.currentColor = (this.currentColor + 2) % 3
      this.addToRadius = 0
    }
    this.lastRender = Date.now()
    if (this.animationState === 'r') window.requestAnimationFrame(this.animation.bind(this))
    if (this.animationState === 's') {
      this.init()
      if (this.animationStopping) this.animationStopping()
    }
  }

  startAnimation () {
    this.animationState = 'r'
    this.lastRender = Date.now()
    this.animation()
  }

  pauseAnimation () {
    this.animationState = 'p'
  }

  stopAnimation () {
    if (this.animationState === 'p') this.init()
    const promise = new Promise((resolve) => {
      if (this.animationState === 'r') {
        this.animationStopping = resolve
      } else {
        resolve()
      }
    })
    this.animationState = 's'
    return promise
  }
}

module.exports = Rings
